export default __webpack_public_path__ + "static/media/KK_R_Right_Bottom_sCrop.0a22c6e1.svg";